<app-fire-foresight-menu></app-fire-foresight-menu>

<!-- BEGIN #content -->
<div id="content" class="app-content">
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a [routerLink]="['/home']">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a>Fire Foresight</a>
        </li>
        <li class="breadcrumb-item" *ngIf="fire && fire.camera">
          <a>Landscape</a>
        </li>
        <li class="breadcrumb-item" *ngIf="fire && fire.camera">
          <a>{{fire.camera.name}}</a>
        </li>
      </ol>
    </div>
  </div>
  
  <div class="wrapper wrapper-content animated fadeInRight">
  
    <div class="row mt-2">
      <div class="col-lg-12 col-sm-12">
        <div class="card mb-4" *ngIf="fire && fire.camera" [ngClass]="{'card-expand':expandImage}">
          <div class="card-header d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
            <span class="flex-grow-1">Latest Imagery : {{fire.camera?.name}}</span>
            <a (click)="expandImage = !expandImage" class="text-inverse text-opacity-50 text-decoration-none btn"><i class="bi bi-fullscreen"></i></a>          
          </div>
          <div class="card-body p-0">
            
            <image-zone-editor *ngIf="showZoneEditor" [siteTwin]="fire.camera.twin" [selectedImage]="selectedImage" (onClosed)="this.showZoneEditor = false"></image-zone-editor>

          </div>
        </div>
      </div>


      <!--<div class="col-lg-12 col-sm-12">
        <div class="card mb-4" [ngClass]="{'card-expand':mapExpand}">
          <div class="card-header d-flex align-items-center bg-inverse bg-opacity-10 fw-400">
            <span class="flex-grow-1">Map</span>
            
            <a (click)="toggleLayers()" data-toggle="card-expand" style="cursor: pointer;" class="text-inverse text-opacity-50 text-decoration-none mr">
              <i [ngClass]="{'bi-layers':!layersSelected,'bi-layers-fill':layersSelected}" class="bi"></i>
            </a>

            <a data-toggle="card-expand" class="text-inverse text-opacity-50 text-decoration-none cursor" title="Expand image" (click)="mapExpand = !mapExpand;resizeMap()">
              <i class="bi bi-fullscreen"></i>
            </a>            
          </div>
          <div class="card-body p-0">
            <app-map #map [mapType]="'googleSat'" [mapheight]="mapHeight"></app-map>
          </div>
        </div>
      </div>
    </div>-->
  
    
  </div>
</div>
<!-- END #content -->
